module.exports = ".invalid-feedback{border:none}\n"